<template>
  <div class="overflow-y-scroll h-full min-h-full">
    <main class="flex-1 relative pb-1 z-0">
      <!-- Page header -->
      <div class="bg-white shadow">
        <div class="px-4 sm:px-6 lg:mx-auto lg:px-8 max-w-7xl">
          <div class="py-6 pb-8 md:flex md:items-center md:justify-between lg:border-t lg:border-cool-gray-200">
            <div class="flex-1 min-w-0">
              <!-- Profile -->
              <div class="flex items-center">
                <div
                  class="h-15 w-15 rounded-full bg-gray-800 shadow-lg text-white flex items-center justify-center text-center text-2xl font-light"
                >
                  <div class="leading-none select-none">
                    {{ forename.charAt(0) }}{{ surname.charAt(0) }}
                  </div>
                </div>
                <div>
                  <div class="flex items-center">
                    <div
                      class="h-15 w-15 rounded-full sm:hidden bg-gray-600 text-white"
                    >
                      {{ forename.charAt(0) }}{{ surname.charAt(0) }}
                    </div>
                    <h1 class="ml-3 text-2xl font-bold leading-7 text-cool-gray-900 sm:leading-9 sm:truncate">
                      {{ getWelcomeText() }}, {{ forename }} {{ surname }}
                    </h1>
                  </div>
                  <dl class="mt-6 flex flex-col sm:ml-3 sm:mt-1 sm:flex-row sm:flex-wrap">
                    <dt class="sr-only">
                      Company
                    </dt>
                    <dd class="flex items-center text-sm leading-5 text-cool-gray-500 font-medium capitalize sm:mr-6">
                      <!-- Heroicon name: office-building -->
                      <svg
                        class="flex-shrink-0 mr-1.5 h-5 w-5 text-cool-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      {{ clubName }}
                    </dd>
                    <dt class="sr-only">
                      Account status
                    </dt>
                    <dd class="mt-3 flex items-center text-sm leading-5 text-cool-gray-500 font-medium sm:mr-6 sm:mt-0 capitalize">
                      <!-- Heroicon name: check-circle -->
                      <svg
                        class="flex-shrink-0 mr-1.5 h-5 w-5 text-green-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      Verified account
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="mt-6 flex space-x-3 md:mt-0 md:ml-4">
              <!-- <span class="shadow-sm rounded-md">
                <button
                  type="button"
                  class="inline-flex items-center px-4 py-2 border border-cool-gray-300 text-sm leading-5 font-medium rounded-md text-cool-gray-700 bg-white hover:text-cool-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:text-cool-gray-800 active:bg-cool-gray-50 transition duration-150 ease-in-out"
                >
                  Add money
                </button>
              </span>
              <span class="shadow-sm rounded-md">
                <button
                  type="button"
                  class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-teal-600 hover:bg-teal-500 focus:outline-none focus:shadow-outline-teal focus:border-teal-700 active:bg-teal-700 transition duration-150 ease-in-out"
                >
                  Send money
                </button>
              </span> -->
            </div>
          </div>
        </div>
      </div>
    </main>

    <div
      v-if="false"
      class="pt-8 pb-32 px-8 max-w-7xl ml-auto mr-auto"
    >
      <h2 class="mx-auto mt-8 text-lg leading-6 font-medium text-cool-gray-900">
        Follow these steps to get started
      </h2>

      <div class="mt-2">
        <Guide />
      </div>

      <div class="mx-auto mt-8">
        <h2 class="text-lg leading-6 font-medium text-cool-gray-900">
          December overview
        </h2>
        <div class="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <!-- Card -->

          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="p-5">
              <div class="flex items-center">
                <div class="flex-shrink-0 w-12 text-center text-cool-gray-400 text-2xl">
                  <i class="fas fa-calendar-check" />
                </div>
                <div class="ml-5 w-0 flex-1">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-cool-gray-500 truncate">
                      Total bookings
                    </dt>
                    <dd>
                      <div class="text-lg leading-7 font-medium text-cool-gray-900">
                        573
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <!-- <div class="bg-cool-gray-50 px-5 py-3">
              <div class="text-sm leading-5">
                <a
                  href="#"
                  class="font-medium text-gray-600 hover:text-gray-900 transition ease-in-out duration-150"
                >
                  View all
                </a>
              </div>
            </div> -->
          </div>

          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="p-5">
              <div class="flex items-center">
                <div class="flex-shrink-0 w-12 text-center  text-cool-gray-400 text-2xl">
                  <i class="fas fa-sack" />
                </div>
                <div class="ml-5 w-0 flex-1">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-cool-gray-500 truncate">
                      Net revenue
                    </dt>
                    <dd>
                      <div class="text-lg leading-7 font-medium text-cool-gray-900">
                        £30,659.45
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <!-- <div class="bg-cool-gray-50 px-5 py-3">
              <div class="text-sm leading-5">
                <a
                  href="#"
                  class="font-medium text-gray-600 hover:text-gray-900 transition ease-in-out duration-150"
                >
                  View report
                </a>
              </div>
            </div> -->
          </div>

          <div class="bg-white overflow-hidden shadow rounded-lg">
            <div class="p-5">
              <div class="flex items-center">
                <div class="flex-shrink-0 w-12 text-center text-cool-gray-400 text-2xl">
                  <i class="fas fa-coins" />
                </div>
                <div class="ml-5 w-0 flex-1">
                  <dl>
                    <dt class="text-sm leading-5 font-medium text-cool-gray-500 truncate">
                      Yeild per round
                    </dt>
                    <dd>
                      <div class="text-lg leading-7 font-medium text-cool-gray-900">
                        £25.71
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <!-- <div class="bg-cool-gray-50 px-5 py-3">
              <div class="text-sm leading-5">
                <a
                  href="#"
                  class="font-medium text-gray-600 hover:text-gray-900 transition ease-in-out duration-150"
                >
                  View report
                </a>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Could this list recent activies instead? E.g check ins, bookings, events along with payments -->
      <h2 class="mx-auto mt-8 text-lg leading-6 font-medium text-cool-gray-900">
        Recent payments
      </h2>

      <div class="block">
        <div class="mx-auto">
          <div class="flex flex-col mt-2">
            <div class="align-middle min-w-full overflow-x-auto shadow overflow-hidden sm:rounded-lg">
              <table class="min-w-full divide-y divide-cool-gray-200">
                <thead>
                  <tr>
                    <th class="px-6 py-3 bg-cool-gray-50 text-left text-xs leading-4 font-medium text-cool-gray-500 uppercase tracking-wider">
                      Transaction
                    </th>
                    <th class="px-6 py-3 bg-cool-gray-50 text-right text-xs leading-4 font-medium text-cool-gray-500 uppercase tracking-wider">
                      Amount
                    </th>
                    <th class="hidden px-6 py-3 bg-cool-gray-50 text-left text-xs leading-4 font-medium text-cool-gray-500 uppercase tracking-wider md:block">
                      Status
                    </th>
                    <th class="px-6 py-3 bg-cool-gray-50 text-right text-xs leading-4 font-medium text-cool-gray-500 uppercase tracking-wider">
                      Date
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-cool-gray-200">
                  <tr class="bg-white">
                    <td class="max-w-0 w-full px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-900">
                      <div class="flex">
                        <a
                          href="#"
                          class="group inline-flex space-x-2 truncate text-sm leading-5"
                        >
                          <!-- Heroicon name: cash -->
                          <svg
                            class="flex-shrink-0 h-5 w-5 text-cool-gray-400 group-hover:text-cool-gray-500 transition ease-in-out duration-150"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <p class="text-cool-gray-500 truncate group-hover:text-cool-gray-900 transition ease-in-out duration-150">
                            Payment from David Brooks
                          </p>
                        </a>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      <span class="text-cool-gray-900 font-medium">£120 </span>
                      GBP
                    </td>
                    <td class="hidden px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-500 md:block">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-yellow-100 text-yellow-800 capitalize">
                        processing
                      </span>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      Nov 11, 2020
                    </td>
                  </tr>

                  <tr class="bg-white">
                    <td class="max-w-0 w-full px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-900">
                      <div class="flex">
                        <a
                          href="#"
                          class="group inline-flex space-x-2 truncate text-sm leading-5"
                        >
                          <!-- Heroicon name: cash -->
                          <svg
                            class="flex-shrink-0 h-5 w-5 text-cool-gray-400 group-hover:text-cool-gray-500 transition ease-in-out duration-150"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <p class="text-cool-gray-500 truncate group-hover:text-cool-gray-900 transition ease-in-out duration-150">
                            Payment from Harry Wilson
                          </p>
                        </a>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      <span class="text-cool-gray-900 font-medium">£245 </span>
                      GBP
                    </td>
                    <td class="hidden px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-500 md:block">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-yellow-100 text-yellow-800 capitalize">
                        processing
                      </span>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      Nov 11, 2020
                    </td>
                  </tr>

                  <tr class="bg-white">
                    <td class="max-w-0 w-full px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-900">
                      <div class="flex">
                        <a
                          href="#"
                          class="group inline-flex space-x-2 truncate text-sm leading-5"
                        >
                          <!-- Heroicon name: cash -->
                          <svg
                            class="flex-shrink-0 h-5 w-5 text-cool-gray-400 group-hover:text-cool-gray-500 transition ease-in-out duration-150"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <p class="text-cool-gray-500 truncate group-hover:text-cool-gray-900 transition ease-in-out duration-150">
                            Payment from Johnny Williams
                          </p>
                        </a>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      <span class="text-cool-gray-900 font-medium">£99 </span>
                      GBP
                    </td>
                    <td class="hidden px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-500 md:block">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-100 text-green-800 capitalize">
                        success
                      </span>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      Nov 10, 2020
                    </td>
                  </tr>

                  <tr class="bg-white">
                    <td class="max-w-0 w-full px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-900">
                      <div class="flex">
                        <a
                          href="#"
                          class="group inline-flex space-x-2 truncate text-sm leading-5"
                        >
                          <!-- Heroicon name: cash -->
                          <svg
                            class="flex-shrink-0 h-5 w-5 text-cool-gray-400 group-hover:text-cool-gray-500 transition ease-in-out duration-150"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <p class="text-cool-gray-500 truncate group-hover:text-cool-gray-900 transition ease-in-out duration-150">
                            Payment from Ben Davies
                          </p>
                        </a>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      <span class="text-cool-gray-900 font-medium">£62 </span>
                      GBP
                    </td>
                    <td class="hidden px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-500 md:block">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-yellow-100 text-yellow-800 capitalize">
                        processing
                      </span>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      Nov 10, 2020
                    </td>
                  </tr>

                  <tr class="bg-white">
                    <td class="max-w-0 w-full px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-900">
                      <div class="flex">
                        <a
                          href="#"
                          class="group inline-flex space-x-2 truncate text-sm leading-5"
                        >
                          <!-- Heroicon name: cash -->
                          <svg
                            class="flex-shrink-0 h-5 w-5 text-cool-gray-400 group-hover:text-cool-gray-500 transition ease-in-out duration-150"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <p class="text-cool-gray-500 truncate group-hover:text-cool-gray-900 transition ease-in-out duration-150">
                            Payment from Molly Sanders
                          </p>
                        </a>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      <span class="text-cool-gray-900 font-medium">£40 </span>
                      GBP
                    </td>
                    <td class="hidden px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-500 md:block">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-100 text-green-800 capitalize">
                        success
                      </span>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      Nov 10, 2020
                    </td>
                  </tr>

                  <tr class="bg-white">
                    <td class="max-w-0 w-full px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-900">
                      <div class="flex">
                        <a
                          href="#"
                          class="group inline-flex space-x-2 truncate text-sm leading-5"
                        >
                          <!-- Heroicon name: cash -->
                          <svg
                            class="flex-shrink-0 h-5 w-5 text-cool-gray-400 group-hover:text-cool-gray-500 transition ease-in-out duration-150"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <p class="text-cool-gray-500 truncate group-hover:text-cool-gray-900 transition ease-in-out duration-150">
                            Payment from Chris Coleman
                          </p>
                        </a>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      <span class="text-cool-gray-900 font-medium">£89 </span>
                      GBP
                    </td>
                    <td class="hidden px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-500 md:block">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-100 text-green-800 capitalize">
                        success
                      </span>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      Nov 10, 2020
                    </td>
                  </tr>

                  <tr class="bg-white">
                    <td class="max-w-0 w-full px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-900">
                      <div class="flex">
                        <a
                          href="#"
                          class="group inline-flex space-x-2 truncate text-sm leading-5"
                        >
                          <!-- Heroicon name: cash -->
                          <svg
                            class="flex-shrink-0 h-5 w-5 text-cool-gray-400 group-hover:text-cool-gray-500 transition ease-in-out duration-150"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <p class="text-cool-gray-500 truncate group-hover:text-cool-gray-900 transition ease-in-out duration-150">
                            Payment from Elliot Edwards
                          </p>
                        </a>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      <span class="text-cool-gray-900 font-medium">£49 </span>
                      GBP
                    </td>
                    <td class="hidden px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-500 md:block">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-100 text-green-800 capitalize">
                        success
                      </span>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      Nov 10, 2020
                    </td>
                  </tr>

                  <tr class="bg-white">
                    <td class="max-w-0 w-full px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-900">
                      <div class="flex">
                        <a
                          href="#"
                          class="group inline-flex space-x-2 truncate text-sm leading-5"
                        >
                          <!-- Heroicon name: cash -->
                          <svg
                            class="flex-shrink-0 h-5 w-5 text-cool-gray-400 group-hover:text-cool-gray-500 transition ease-in-out duration-150"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <p class="text-cool-gray-500 truncate group-hover:text-cool-gray-900 transition ease-in-out duration-150">
                            Payment from Philippa Richards
                          </p>
                        </a>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      <span class="text-cool-gray-900 font-medium">£44 </span>
                      GBP
                    </td>
                    <td class="hidden px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-500 md:block">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-100 text-green-800 capitalize">
                        success
                      </span>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      Nov 10, 2020
                    </td>
                  </tr>

                  <tr class="bg-white">
                    <td class="max-w-0 w-full px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-900">
                      <div class="flex">
                        <a
                          href="#"
                          class="group inline-flex space-x-2 truncate text-sm leading-5"
                        >
                          <!-- Heroicon name: cash -->
                          <svg
                            class="flex-shrink-0 h-5 w-5 text-cool-gray-400 group-hover:text-cool-gray-500 transition ease-in-out duration-150"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <p class="text-cool-gray-500 truncate group-hover:text-cool-gray-900 transition ease-in-out duration-150">
                            Payment from Morgan Atkinson
                          </p>
                        </a>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      <span class="text-cool-gray-900 font-medium">£29 </span>
                      GBP
                    </td>
                    <td class="hidden px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-500 md:block">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-100 text-green-800 capitalize">
                        success
                      </span>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      Nov 10, 2020
                    </td>
                  </tr>

                  <tr class="bg-white">
                    <td class="max-w-0 w-full px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-900">
                      <div class="flex">
                        <a
                          href="#"
                          class="group inline-flex space-x-2 truncate text-sm leading-5"
                        >
                          <!-- Heroicon name: cash -->
                          <svg
                            class="flex-shrink-0 h-5 w-5 text-cool-gray-400 group-hover:text-cool-gray-500 transition ease-in-out duration-150"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <p class="text-cool-gray-500 truncate group-hover:text-cool-gray-900 transition ease-in-out duration-150">
                            Payment from Eric Lowe
                          </p>
                        </a>
                      </div>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      <span class="text-cool-gray-900 font-medium">£152 </span>
                      GBP
                    </td>
                    <td class="hidden px-6 py-4 whitespace-no-wrap text-sm leading-5 text-cool-gray-500 md:block">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-100 text-green-800 capitalize">
                        success
                      </span>
                    </td>
                    <td class="px-6 py-4 text-right whitespace-no-wrap text-sm leading-5 text-cool-gray-500">
                      Nov 10, 2020
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- Pagination -->
              <nav class="bg-white px-4 py-3 flex items-center justify-between border-t border-cool-gray-200 sm:px-6">
                <div class="hidden sm:block">
                  <p class="text-sm leading-5 text-cool-gray-700">
                    Showing
                    <span class="font-medium">1</span>
                    to
                    <span class="font-medium">10</span>
                    of
                    <span class="font-medium">20</span>
                    results
                  </p>
                </div>
                <div class="flex-1 flex justify-between sm:justify-end">
                  <a
                    href="#"
                    class="relative inline-flex items-center px-4 py-2 border border-cool-gray-300 text-sm leading-5 font-medium rounded-md text-cool-gray-700 bg-white hover:text-cool-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-cool-gray-100 active:text-cool-gray-700 transition ease-in-out duration-150"
                  >
                    Previous
                  </a>
                  <a
                    href="#"
                    class="ml-3 relative inline-flex items-center px-4 py-2 border border-cool-gray-300 text-sm leading-5 font-medium rounded-md text-cool-gray-700 bg-white hover:text-cool-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-cool-gray-100 active:text-cool-gray-700 transition ease-in-out duration-150"
                  >
                    Next
                  </a>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="h-full flex items-center justify-center font-bold text-2xl">
      <div class="-mt-44">
        Work in Progress
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Guide from '@/app/shared/components/tutorial/guide.vue';

export default {
  name: 'Home',

  components: {
    Guide,
  },

  data() {
    return {

    };
  },

  computed: {
    ...mapState({
      username: state => state.user.username,
      emailAddress: state => state.user.emailAddress,
      forename: state => state.user.forename,
      surname: state => state.user.surname,
      tenant: state => state.user.tenant,
      selectedClub: state => state.club.selectedClub,
    }),

    clubName() {
      if (this.selectedClub && this.selectedClub.name) {
        return this.selectedClub.name;
      }
      return 'No club selected';
    },
  },

  watch: {

  },


  mounted() {

  },

  methods: {
    getWelcomeText() {
      const date = new Date();
      const morning = new Date().setHours(12, 0, 0);
      const afternoon = new Date().setHours(16, 0, 0);

      if (date < morning) {
        return 'Good morning';
      } if (date < afternoon) {
        return 'Good afternoon';
      }
      return 'Good evening';
    },
  },

};
</script>
